import { useGetPerson } from '@my-pages/hooks/useGetPerson';
import AssignmentCard from "@my-pages/features/membership/components/AssigmentCard.tsx";
import {SuspenseQueryErrorHandling} from "@shared/components/SuspenseQueryErrorHandling.tsx";


const AssignmentCards = () => {
    const member = useGetPerson();
    if (!member) return <></>;

    return member.assignments && member.assignments.length > 0
        ? member.assignments.map((assignment) => {
              return (
                  <AssignmentCard
                      key={assignment.id}
                      assignment={assignment}
                  />
              );
          })
        : null;
};
const Assignments = () => {
    return (
        <SuspenseQueryErrorHandling errorMessage='Kunde inte hämta uppgfiter kring förtroendeuppdrag.'>
            <AssignmentCards />
        </SuspenseQueryErrorHandling>
    );
};

export default Assignments;
